<div id="bannerUrl" class="tab-pane active">
  <form *ngIf="bannerURLgrpForm">
    <div id="bannerUrlRow" class="row url-data-section">
      <label class="url_label" i18n="@@banner-url.label.note-customurl-text">Note: This functionality requires a
        connected device to access the custom URL.</label>
      <div id="bannerUrlFormgrp" class="form-group col-md-6 custom-url-input">
        <label for="customUrl"><span i18n="@@banner-url.text.customurl">Custom URL</span><span
            class="text-danger">*</span></label>
        <input type="text" class="form-control" id="customUrl" [(ngModel)]="bannerURLgrpForm.customURL"
          placeholder={{customURLPlaceholderText}} (keyup)="emitURLData($event)" name="customUrl" />
        <div id="bannerUrlErr" *ngIf="!isUrlValid" class="formfield_err_msg" [innerHTML]='emailValidationMsg'>
        </div>
      </div>
    </div>
  </form>
</div>